import { render, staticRenderFns } from "./OperationConfig.vue?vue&type=template&id=a04e6042&scoped=true"
import script from "./OperationConfig.vue?vue&type=script&lang=js"
export * from "./OperationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04e6042",
  null
  
)

export default component.exports